<template>
  <!-- Page Content -->
  <div class="h-100 d-flex flex-column">
    <!-- Row: title -->
    <div class="row f-row mb-2 markets-chart-title d-flex align-items-center">
      <div class="col col-6" style="font-size: 1rem">
        Commodity Price Comparison
      </div>
      <slot name="spot"></slot>
    </div>
    <!-- First row: controls -->
    <div
      class="row f-row mt-2 justify-content-center container-controls-interval"
    >
      <div class="txt-label-primary-2 container-btn-play">
        <button
          @click="onUserPlay"
          :class="{ onShowMarkets: !play }"
          class="showMarkets btn"
        >
          <i :class="{ 'fa fa-pause': play, 'fa fa-play': !play }"></i>
        </button>
      </div>
      <div
        class="col text-left txt-label-primary-2"
        :class="screenWidth < 1400 ? 'col-9' : 'col-8'"
      >
        <div
          class="div-mid-align btn-toolbar"
          role="toolbar"
          aria-label="Toolbar with button groups"
        >
          <div class="btn-group btn-group-toggle btn-block" role="group">
            <template v-if="controls === 'large'">
              <button
                v-for="timeframe in intervalTime"
                :key="timeframe"
                type="button"
                class="btn btn-bucket btn-Mkt"
                @click="pickedTime(timeframe)"
                :class="{ active: pickedTimeframe === timeframe }"
              >
                {{ timeframe }}
              </button>
            </template>
          </div>
        </div>
      </div>
      <div
        class="col col-auto txt-label-primary-2"
        style="justify-content: end; padding: 0 0 0 30px!important;"
      >
        <span> Range: {{ chartDateRange }} </span>
      </div>
    </div>
    <div class="row f-row h-100">
      <!-- Legends -->
      <!-- :class="screenWidth < 1280 ? 'col-3' : 'col-2'" -->
      <div style="margin-top: 15px!important; width: 190px!important;">
        <template v-for="(infoComm, i) in infoCommodityTypes">
          <div
            v-if="infoComm.label.includes('elect All')"
            class="row f-row mb-2"
            style="padding-left: 5px!important;"
            :key="'sa-' + i"
          >
            <div
              class="col col-12 p-0 comm-type-header ml-1"
              @click="onUserShowCommTypes(infoComm)"
            >
              <span class="p-checkbox p-component comm-type-check">
                <span
                  class="p-checkbox-box"
                  :class="{ 'p-highlight': infoComm.show }"
                >
                  <span
                    class="p-checkbox-icon"
                    :class="infoComm.show ? 'pi pi-check' : ''"
                  ></span>
                </span>
              </span>
              <span class="comm-type-label">{{ infoComm.label }}</span>
            </div>
          </div>
          <div
            v-else-if="groupOptions(infoComm).length > 0"
            class="row f-row mb-2"
            style="padding-left: 5px!important;"
            :key="'ms-' + i"
          >
            <div
              class="col col-12 p-0 comm-type-header ml-1"
              @click="onUserToggleTypeAll(infoComm)"
            >
              <span class="p-checkbox p-component comm-type-check">
                <span
                  class="p-checkbox-box"
                  :class="{ 'p-highlight': groupSomeSelected(infoComm) }"
                >
                  <span
                    class="p-checkbox-icon"
                    :class="
                      groupAllSelected(infoComm)
                        ? 'pi pi-check'
                        : groupSomeSelected(infoComm)
                        ? 'pi pi-minus'
                        : ''
                    "
                  ></span>
                </span>
              </span>
              <span class="comm-type-label">{{ infoComm.label }}</span>
            </div>
            <div class="col col-12 p-0">
              <MultiSelect
                class="p-column-filter comm-type-multiselect"
                :value="groupSelections[infoComm.label] || []"
                :options="groupOptions(infoComm)"
                :filter="groupOptions(infoComm).length > 8"
                :placeholder="infoComm.label"
                scrollHeight="300px"
                @change="onUserGroupMultiSelect(infoComm, $event)"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </div>
          </div>
        </template>
      </div>

      <!-- Second row: charts -->
      <div
        style="margin-top: 5px!important; width: calc(100% - 190px)!important; height: calc(100vh - 142px) !important;"
      >
        <!-- Second column: -->
        <div class="col text-center col-12 h-100">
          <div class="h-100 d-flex flex-column">
            <!-- Second row: Chart -->
            <div class="row f-row justify-content-center h-100">
              <div
                class="col col-12 text-center progress-div"
                v-if="showLoading | emptySelection"
              >
                <QSLoading
                  v-if="!emptySelection"
                  :isLoading="showLoading"
                  :size="40"
                  :colorTheme="colorTheme"
                />
                <span v-else>Select commodities</span>
              </div>
              <div
                class="col col-12 text-center"
                v-else-if="commoditiesData.length === 0"
                style="position: absolute; left: 0; top: 50%; z-index: 10000000;"
              >
                No Data Available
              </div>
              <div class="col col-12" style="height:100%;width:100%">
                <div class="h-100 d-flex flex-column">
                  <div
                    id="multi_commodity-div"
                    style="width: 100%; height: 100%;"
                  >
                    <svg id="svg-multi_commodity"></svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { D3Chart } from "@/_core/charts/D3Chart";
import { D3HoverCommodities } from "@/_core/charts/D3ChartHoverEffects";
import {
  formatDate_YMD,
  sortByKey,
  lengthByDate,
  dateRangeToString,
} from "@/_core/_helpers/_helpers";
import {
  tDays,
  formatPercent,
  formatPercentSm,
  dateFormat,
  currencyFormat,
  colorSelectionMulti,
  textinactive,
  textactive,
  colorDarkHedge,
} from "@/_core/_helpers/_parametric_tools";
import { gatewayService } from "@/_services/gateway.service";
import {
  utcParse,
  min as minD3,
  max as maxD3,
  scaleLinear,
  interpolateRgb,
  timeParse,
  keys,
  select,
  selectAll,
  axisLeft,
  axisBottom,
  scaleBand,
  timeFormat,
} from "d3";
import { getConversions } from "@/_core/data/Markets";
import { cleanAndUnionName } from "@/_core/charts/D3Chart";
import { getCandleData } from "@/_core/data/api_calls/getCandleData";
import MultiSelect from "primevue/multiselect";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "CommoditiesMulti",
  components: { MultiSelect, QSLoading },
  props: {
    controls: { required: true },
    selectedCommodity: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
    // ============ Data Classes ===============
    processData: { required: true },
    commoditySpecs: { required: true },
  },
  data() {
    return {
      chartDateRange: "...",
      color: null,
      colorLegends: colorDarkHedge(this.colorTheme),
      colorSel: JSON.parse(JSON.stringify(colorSelectionMulti)),
      commodityConversions: [{ id: 0, text: "...", value: 1 }],
      commoditiesData: [],
      commoditiesDataRaw: [],
      currencies: [],
      commdtyDataCopySeries: [],
      currencyFormat: currencyFormat,
      currencyTarget: [
        {
          name: "RINGGIT",
          representation: "MYR",
        },
        {
          name: "DOLLAR",
          representation: "USD",
        },
        {
          name: "EURO",
          representation: "EUR",
        },
      ],
      commoditiesDataFilterHover: { series: [] },
      D3Chart: null,
      D3HoverCommodities: null,
      dateFormat: dateFormat,
      daysSelection: tDays,
      emptySelection: false,
      expandWorld: false,
      groupSelections: {},
      formatPercent: formatPercentSm,
      formatPercent1: formatPercent,
      hideCommodities: false,
      hideWorld: false,
      initCurrencyDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 11),
      ),
      infoCommodityTypes: [],
      interval: null,
      intervalTime: [
        "1D",
        "2D",
        "3D",
        "4D",
        "1W",
        "2W",
        "1M",
        "2M",
        "3M",
        "6M",
        "9M",
        "1Y",
        "2Y",
        "3Y",
        "4Y",
        "5Y",
        "10Y",
      ],
      minMaxYAxis: [0, 1],
      keys: {},
      lastPrices: [],
      logo: require("@/assets/images/symbol_blue.svg"),
      pickedTimeframe: "2Y",
      play: false,
      rets: [],
      showLoading: false,
      svgNode: null,
      screenWidth: 0,
      screenHeight: 0,
    };
  },
  created() {
    this.D3Chart = new D3Chart("multi_commodity-div", "svg-multi_commodity");
    this.D3HoverCommodities = new D3HoverCommodities();
    // Obtain of conversion values
    this.commodityConversions = getConversions();
  },
  mounted() {
    this.readCommoditiesData();
    this.getInfoCommodityTypes();
    let _this = this;
    this.updateScreenWidth();
    window.addEventListener("resize", function() {
      _this.callWidth();
    });
  },
  watch: {
    colorTheme() {
      this.callWidth();
    },
    commoditiesDataFilterHover() {
      this.syncGroupSelections();
    },
  },
  methods: {
    onUserPlay() {
      this.play = !this.play;
      if (this.play) {
        this.interval = setInterval(this.stepLoop, 1000);
      } else {
        clearInterval(this.interval);
      }
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },
    callWidth() {
      this.updateScreenWidth();
      if (this.commoditiesData.length > 0) {
        this.renderChartMethod();
      }
    },
    getInfoCommodityTypes() {
      const commType = this.commoditySpecs.map((d) =>
        d.fk_idproduct.toUpperCase(),
      );
      const objTypeComm = {
        label: "Deselect All",
        colorBdr: this.colorLegends,
        colorBck: this.colorLegends,
        commoditiesByType: commType,
        className: "",
        show: true,
      };
      this.infoCommodityTypes.push(objTypeComm);

      this.commoditySpecs.forEach((comm) => {
        let lbl =
          comm.fk_idcommoditytype.charAt(0).toUpperCase() +
          comm.fk_idcommoditytype.slice(1).toLowerCase();
        const findIndex = this.infoCommodityTypes.findIndex(
          (item) => item.label === lbl,
        );
        const nameProductUpperCase = comm.fk_idproduct.toUpperCase();

        if (findIndex !== -1) {
          this.infoCommodityTypes[findIndex].commoditiesByType.push(
            nameProductUpperCase,
          );
        } else {
          const nameNonSpaces = cleanAndUnionName(lbl);
          const valueObj = {
            label: lbl,
            colorBdr: this.colorLegends,
            colorBck: this.colorLegends,
            commoditiesByType: [nameProductUpperCase],
            className: nameNonSpaces,
            show: true,
          };
          this.infoCommodityTypes.push(valueObj);
        }
      });
    },
    getMinMaxYAxis(data) {
      return [
        minD3(data.series, (d) => minD3(d.values)),
        maxD3(data.series, (d) => maxD3(d.values)),
      ];
    },
    // =================== commodities =================== //
    parseCommoditiesDataRaw(columns, data) {
      return {
        y: "Changes (%)",
        series: data.map((d) => ({
          name: d.product_name.replace(/, ([\w-]+).*/, " $1").toUpperCase(),
          short_name: d.product_representation
            .replace(/, ([\w-]+).*/, " $1")
            .toUpperCase(),
          symbol: d.symbol.replace(/, ([\w-]+).*/, " $1").toUpperCase(),
          units: d.unit_name.replace(/, ([\w-]+).*/, " $1").toUpperCase(),
          short_unit: d.unit_representation.replace(/, ([\w-]+).*/, " $1"),
          currency: d.currency_representation
            .replace(/, ([\w-]+).*/, " $1")
            .toUpperCase(),
          is_cents: +d.is_cents,
          contract_size: +d.contract_size,
          latest: +d[columns[columns.length - 1]],
          values: columns.map((k) => +d[k]),
        })),
        dates: columns.map(utcParse("%Y-%m-%d")),
      };
    },
    renderChartMethod() {
      const rightSvg = this.screenWidth < 1280 ? [0.5, 200] : [0.25, 275];
      const leftSvg = [0.085, 60];

      // === set SVG canvas
      this.svgNode = this.D3Chart.setSVG(
        0.02,
        500,
        rightSvg[0],
        rightSvg[1],
        0.8,
        45,
        leftSvg[0],
        leftSvg[1],
        this.colorTheme,
        this.logo,
      );
      this.minMaxYAxis = this.getMinMaxYAxis(this.commoditiesDataFilterHover);
      // === set axis
      let xDates = this.commoditiesData.dates.map((d) => (d.date = d));
      this.svgNode = this.D3Chart.setAxis(
        this.svgNode,
        xDates,
        this.minMaxYAxis,
        this.dateFormat,
        60,
        8,
        false,
        [],
        true,
        true,
        true,
      );
      // === ordered data and colors
      this.recalculateScaleColors(this.commoditiesDataFilterHover.series);
      // === lines
      this.svgNode = this.D3Chart.multiLine(
        this.svgNode,
        this.commoditiesDataFilterHover,
        this.rets.map((d) => this.color(d)),
        2,
        -1,
        false,
        "short_name",
      );
      // set the 2nd x range and domain
      this.svgNode.xMax = 10;
      let xInit =
        this.svgNode.x(xDates[xDates.length - 1]) + this.svgNode.x.bandwidth();
      this.svgNode.xRight = scaleLinear()
        .range([xInit, xInit + this.svgNode.margin.right * 0.5])
        .domain([0, this.svgNode.xMax])
        .nice();
      this.svgNode.step =
        this.svgNode.height / this.commoditiesDataFilterHover.series.length;
      let sortedData = sortByKey(
        this.commoditiesDataFilterHover.series,
        "latest",
      );
      // Create connecting lines
      this.svgNode = this.D3Chart.orderLines(
        this.svgNode,
        sortedData,
        this.color,
        1,
        -1,
        "short_name",
        "latest",
        "name",
        this.mouseout,
        this.hoverElements,
        true,
        0.8,
      );
      //Create buttons
      const isLargeScreen = this.screenWidth < 1280 || this.screenHeight < 750;
      this.svgNode = this.D3Chart.orderButtons(
        this.svgNode,
        sortedData,
        this.color,
        textinactive(this.colorTheme),
        "",
        "short_name",
        "latest",
        "short_name",
        isLargeScreen ? 0.65 : 0.8,
        1,
        2,
        "NAME",
        "name",
        true,
        this.mouseout,
        this.hoverElements,
        this.handleLegendsComm,
        "right",
        this.screenWidth >= 1280,
        this.screenHeight < 600 || this.screenHeight < 750 ? 4 : 2,
      );
      // === add hover Fx for Forecast Chart/part
      this.D3HoverCommodities.hoverFct(
        this.svgNode,
        "commoditiesDataFilterHover",
        "COMM",
        this.dateFormat,
        this.currencyFormat,
        this.formatPercent1,
        textactive(this.colorTheme),
        textactive(this.colorTheme),
        this.processData,
        2,
        textinactive(this.colorTheme),
        "color",
        this.colorTheme,
        this,
        4,
      );
    },
    recalculateScaleColors(data) {
      this.rets = data.map((d) => d.latest);
      let min = minD3(this.rets, function(d) {
        return Number.isFinite(d) ? d : Infinity;
      });
      let max = maxD3(this.rets, function(d) {
        return Number.isFinite(d) ? d : -Infinity;
      });
      let minMax = Math.max(Math.abs(min), Math.abs(max));
      this.rets = data.map((d) => d.latest);
      let sortedValues = this.rets.slice().sort((a, b) => a - b);

      let domainValues = [
        sortedValues[0],
        sortedValues[Math.floor(sortedValues.length * 0.12)],
        sortedValues[Math.floor(sortedValues.length * 0.25)],
        sortedValues[Math.floor(sortedValues.length * 0.38)],
        sortedValues[Math.floor(sortedValues.length * 0.51)],
        sortedValues[Math.floor(sortedValues.length * 0.64)],
        sortedValues[Math.floor(sortedValues.length * 0.77)],
        sortedValues.at(-1),
      ];

      this.color = scaleLinear()
        .domain(domainValues)
        .range(this.colorSel)
        .interpolate(interpolateRgb);

      return minMax;
    },
    updateAxisY(minimal, maximal) {
      this.svgNode.y = scaleLinear()
        .range([this.svgNode.height, 0])
        .domain([minimal, maximal])
        .nice();

      this.svgNode.yAxis = axisLeft(this.svgNode.y)
        .tickSize(-this.svgNode.width)
        .tickSizeOuter(0)
        .tickPadding(10)
        .ticks(8);

      select(".axis--y")
        .transition()
        .duration(1000)
        .call(this.svgNode.yAxis);
    },
    updateAxisX(xData) {
      let xDates = xData.map((d) => (d.date = d));
      this.svgNode.x = scaleBand()
        .range([0, this.svgNode.width])
        .domain(
          xDates.map(function(d) {
            return d.date;
          }),
        );

      const xtickdelta = Math.ceil(60 / (this.svgNode.width / xDates.length));
      this.svgNode.xAxis = axisBottom(this.svgNode.x)
        .tickValues(
          this.svgNode.x.domain().filter(function(d, i) {
            return !((i + Math.floor(xtickdelta / 2)) % xtickdelta);
          }),
        )
        .tickFormat(timeFormat(this.dateFormat));

      select(".axis--x")
        .transition()
        .duration(1000)
        .call(this.svgNode.xAxis);

      /* update elements chart */
      // this.recalculateElementsChart();
      this.renderChartMethod();
    },
    recalculateElementsChart(updateAxisX = false) {
      const [minimal, maximal] = this.getMinMaxYAxis(
        this.commoditiesDataFilterHover,
      );
      //Update axis Y
      this.updateAxisY(minimal, maximal);
      //Update axis X
      if (updateAxisX) {
        this.updateAxisX(this.commoditiesDataFilterHover.dates);
      }
      this.commdtyDataCopySeries = this.commoditiesDataFilterHover.series;
      // Recalculate scale colors
      this.recalculateScaleColors(this.commdtyDataCopySeries);

      let sortedData = sortByKey(this.commdtyDataCopySeries, "latest");
      this.svgNode.step = this.svgNode.height / (sortedData.length - 1);
      let sortedDataLegend = sortByKey(this.commoditiesData.series, "latest");

      this.D3HoverCommodities.updateElementsChart({
        _this: this,
        data: this.commoditiesDataFilterHover,
        color: this.color,
        colorSelection: this.rets.map((d) => this.color(d)),
        sortedData: sortedDataLegend,
        lineWidth: 2,
        hoverLineWidth: 4,
        idx: "name",
        onMouseOut: this.mouseout,
        onHoverElements: this.hoverElements,
        isEvent: true,
        isUpdateHoverElements: true,
        elementLegends: {
          onClickLegends: this.handleLegendsComm,
          color: this.color,
        },
      });
    },
    // ================ User interactions  ==================== ================ ================
    hoverElements(d, name = "NAME", nameAux = "name") {
      const selectElements = [
        "sortLineOne",
        "sortLineTwo",
        "sortLineThree",
        "legendB",
        "sortText",
        "multiLines",
      ];
      selectElements.forEach((element) => {
        const nameNonSpaces = cleanAndUnionName(d[nameAux]);
        const selectClass =
          element === "legendB" || element === "multiLines"
            ? `${element !== "multiLines" ? name : ""}${nameNonSpaces}`
            : nameNonSpaces;

        selectAll(`.multiLinesGroup path`).classed("highlighted", false);
        selectAll(`.multiLinesGroup path`).classed("highlightedBind", false);
        selectAll(`.${element} rect`).classed("highlightedBind", false);
        selectAll(`.${element}s line`).classed("highlightedBind", false);
        selectAll(`.${element}s text`).classed("highlightedBind", false);

        select(`.${element}${selectClass}`)
          .classed("highlightedBind", true)
          .style("stroke-width", function() {
            if (element !== "legendB" && element !== "sortText") {
              return this.style.strokeWidth === "0" ? "0" : 4;
            } else {
              return this.style.strokeWidth;
            }
          });
        select(`.${element}${selectClass} path`)
          .classed("highlighted", true)
          .style("stroke-width", function() {
            if (element !== "legendB" && element !== "sortText") {
              return this.style.strokeWidth === "0" ? "0" : 4;
            } else {
              return this.style.strokeWidth;
            }
          });
      });
    },
    mouseout() {
      const selectElements = [
        "sortLineOne",
        "sortLineTwo",
        "sortLineThree",
        "legendB",
        "sortText",
        "multiLines",
      ];
      selectElements.forEach((element) => {
        selectAll(`.multiLinesGroup path`)
          .classed("highlighted", false)
          .style("stroke-width", function() {
            return this.style.strokeWidth === "0" ? "0" : 2;
          });
        selectAll(`.multiLinesGroup path`)
          .classed("highlightedBind", false)
          .style("stroke-width", function() {
            return this.style.strokeWidth === "0" ? "0" : 2;
          });
        selectAll(`.${element} rect`)
          .classed("highlightedBind", false)
          .style("stroke-width", function() {
            return this.style.strokeWidth === "0" ? "0" : 2;
          });
        selectAll(`.${element}s line`)
          .classed("highlightedBind", false)
          .style("stroke-width", function() {
            return this.style.strokeWidth === "0" ? "0" : 2;
          });
        selectAll(`.${element}s text`).classed("highlightedBind", false);
      });
    },
    handleLegendTransition(
      d,
      showLegendsTypeComm,
      name = "NAME",
      showLegends = false,
      isLastCall = true,
    ) {
      const isNameObj = typeof d === "string" ? d : d.name;
      const nameNonSpaces = cleanAndUnionName(isNameObj);
      let btnLegend = select(`rect.legendBNAME${nameNonSpaces}`);
      const selectElements = [
        "line.sortLineOne",
        "line.sortLineTwo",
        "rect.legendB",
        "path.multiLines",
      ];

      selectElements.forEach((element) => {
        const isElemLegend = element.includes("legendB");
        const selectClass = isElemLegend
          ? `${name}${nameNonSpaces}`
          : nameNonSpaces;

        try {
          const selectedElement = select(`${element}${selectClass}`);

          const opacityPath = showLegendsTypeComm
            ? showLegends
            : btnLegend.node() === null ||
              btnLegend?.style("fill-opacity") === "0";

          // Show stroke and fill elements
          if (opacityPath) {
            if (isElemLegend) {
              btnLegend
                .transition()
                .duration(500)
                .style("fill-opacity", 2);
            } else {
              selectedElement
                .transition()
                .duration(500)
                .style("stroke-width", 2);
            }
            // add the elements to the data
            const commFilter = this.commoditiesData.series.filter((d) => {
              const isNotInHoverSeries = !this.commoditiesDataFilterHover.series.some(
                (comm) =>
                  comm.short_name === isNameObj || comm.name === isNameObj,
              );
              if (isNotInHoverSeries) {
                return d.short_name === isNameObj || d.name === isNameObj;
              }
              return false;
            });
            Object.assign(this, {
              commoditiesDataFilterHover: {
                dates: this.commoditiesData.dates,
                series: [
                  ...this.commoditiesDataFilterHover.series,
                  ...commFilter,
                ],
                y: this.commoditiesData.y,
              },
            });
            this.emptySelection =
              this.commoditiesDataFilterHover?.series?.length == 0;
            if (isLastCall) {
              this.showOrHideSelectAll();
            }
          }
          // Hide stroke and fill elements
          else {
            if (isElemLegend) {
              btnLegend
                .transition()
                .duration(500)
                .style("fill-opacity", 0);
            } else {
              if (!element.includes("path")) {
                selectedElement
                  .transition()
                  .duration(500)
                  .style("stroke-width", 0);
              }
            }
            const commFilter = this.commoditiesDataFilterHover.series.filter(
              (d) => d.short_name !== isNameObj && d.name !== isNameObj,
            );
            // Delete element from data
            Object.assign(this, {
              commoditiesDataFilterHover: {
                dates: this.commoditiesData.dates,
                series: [...commFilter],
                y: this.commoditiesData.y,
              },
            });
            this.emptySelection =
              this.commoditiesDataFilterHover?.series?.length == 0;
          }
          if (isLastCall) {
            this.showOrHideSelectAll();
            /* update elements chart */
            this.renderChartMethod();
            // this.recalculateElementsChart();
          }
        } catch (error) {
          console.error({ error });
          error;
        }
      });
    },
    handleLegendsComm(d, name = "NAME") {
      this.handleLegendTransition(d, false, name);
    },
    handleLegendsCommType(d, showLegends, isLastCall, name = "NAME") {
      this.handleLegendTransition(d, true, name, showLegends, isLastCall);
    },
    showOrHideSelectAll() {
      const isAllSelect = this.commoditiesDataFilterHover.series.length > 0;
      this.infoCommodityTypes.forEach((d, i) => {
        if (d.label.includes("elect All")) {
          this.$set(this.infoCommodityTypes, i, {
            ...d,
            show: isAllSelect,
            label: isAllSelect ? "Deselect All" : "Select All",
          });
        }
      });
    },
    onUserShowCommTypes(commType) {
      let show;
      const updateCommodities = (showComm) => {
        const commoditiesByType = commType.commoditiesByType;
        commoditiesByType.forEach((d, i) => {
          this.handleLegendsCommType(
            d,
            showComm,
            i === commoditiesByType.length - 1,
          );
        });
      };

      if (commType.label.includes("elect All")) {
        show = !commType.show;
        this.infoCommodityTypes.forEach((d, i) => {
          this.$set(this.infoCommodityTypes, i, { ...d, show });
        });
        updateCommodities(show);
      } else {
        this.infoCommodityTypes.forEach((d, i) => {
          if (d.label === commType.label) {
            show = !d.show;
            this.$set(this.infoCommodityTypes, i, { ...d, show });
          }
        });
        updateCommodities(show);
      }
    },
    seriesHasValue(series, value) {
      return (
        Array.isArray(series) &&
        series.some(
          (serie) => serie.short_name === value || serie.name === value,
        )
      );
    },
    groupOptions(typeEntry) {
      const series =
        (this.commoditiesData && this.commoditiesData.series) || [];
      const source = series.length
        ? typeEntry.commoditiesByType.filter((value) =>
            this.seriesHasValue(series, value),
          )
        : typeEntry.commoditiesByType;
      return [...new Set(source)];
    },
    groupShownValues(typeEntry) {
      const shown = typeEntry.commoditiesByType.filter((value) =>
        this.seriesHasValue(this.commoditiesDataFilterHover.series, value),
      );
      return [...new Set(shown)];
    },
    groupAllSelected(typeEntry) {
      const options = this.groupOptions(typeEntry);
      return (
        options.length > 0 &&
        this.groupShownValues(typeEntry).length === options.length
      );
    },
    groupSomeSelected(typeEntry) {
      return this.groupShownValues(typeEntry).length > 0;
    },
    onUserToggleTypeAll(typeEntry) {
      const options = this.groupOptions(typeEntry);
      const shown = this.groupShownValues(typeEntry);
      const selectAll = shown.length < options.length;
      const targets = options.filter((value) =>
        selectAll ? !shown.includes(value) : shown.includes(value),
      );
      if (targets.length === 0) return;
      targets.forEach((value, i) => {
        this.handleLegendsCommType(value, selectAll, i === targets.length - 1);
      });
    },
    onUserGroupMultiSelect(typeEntry, event) {
      const newSelection = (event && event.value) || [];
      const shown = this.groupShownValues(typeEntry);
      const toShow = newSelection.filter((v) => !shown.includes(v));
      const toHide = shown.filter((v) => !newSelection.includes(v));
      const ops = [
        ...toShow.map((v) => ({ value: v, show: true })),
        ...toHide.map((v) => ({ value: v, show: false })),
      ];
      if (ops.length === 0) return;
      ops.forEach((op, i) => {
        this.handleLegendsCommType(op.value, op.show, i === ops.length - 1);
      });
    },
    syncGroupSelections() {
      if (!this.infoCommodityTypes.length) return;
      if (
        !this.commoditiesDataFilterHover ||
        !Array.isArray(this.commoditiesDataFilterHover.series)
      ) {
        return;
      }
      this.infoCommodityTypes.forEach((typeEntry) => {
        if (typeEntry.label.includes("elect All")) return;
        this.$set(
          this.groupSelections,
          typeEntry.label,
          this.groupShownValues(typeEntry),
        );
      });
    },
    stepLoop() {
      let index = Object.keys(this.daysSelection).indexOf(this.pickedTimeframe);
      if (index === 0) {
        index = Object.keys(this.daysSelection).length - 1;
      } else {
        index -= 1;
      }
      this.pickedTimeframe = Object.keys(this.daysSelection)[index];
      this.parseDataCommodities();
    },
    parseCommoditiesData(data) {
      function divideArray(data, divisor) {
        for (var i = 0, length = data.length; i < length; i++) {
          data[i] = data[i] / divisor - 1;
        }
        return data;
      }
      const _this = this;
      for (let i = 0; i < data.dates.length; i++) {
        data.dates[i] = timeParse("%Y-%m-%dT%H:%M:%S.%LZ")(data.dates[i]);
      }
      const selectedD = lengthByDate(this.pickedTimeframe, data.dates);
      data.dates = data.dates.slice(-selectedD - 1);
      this.chartDateRange = dateRangeToString(
        data.dates[0],
        data.dates[data.dates.length - 1],
        true,
        " \u2192 ",
      );
      data.series.forEach(function(d) {
        d.latestP = d.values[d.values.length - 1];
        d.valuesP = d.values.slice(-selectedD - 1);
        d.values = d.values.slice(-selectedD - 1);
        d.valuesPerc = divideArray(
          d.values.slice(-selectedD - 1),
          d.values[d.values.length - selectedD - 1],
        );
        d.latest = d.values[d.values.length - 1];
        d.latestP = d.valuesPerc.at(-1);
        d.currRepresentation = _this.getCurrRepresentation(d);
      });
      return data;
    },
    getCurrRepresentation(d) {
      const findCurr = this.currencyTarget.find(
        (curr) => curr.name == d.currency,
      );
      let conversion = "";
      if (d.currency === "DOLLAR" && !findCurr) {
        conversion = `(USD/${d.short_unit})`;
      } else {
        conversion = `(${findCurr.representation}/${d.short_unit})`;
      }
      return conversion;
    },
    parseDataCommodities(isRenderChart = false) {
      this.commoditiesData = this.parseCommoditiesData(
        JSON.parse(JSON.stringify(this.commoditiesDataRaw)),
      );
      this.commdtyDataCopySeries = this.commoditiesData.series;

      if (isRenderChart) {
        this.commoditiesDataFilterHover = this.commoditiesData;
        this.emptySelection = false;
        this.renderChartMethod();
      } else {
        // update the data with the selected commodities
        this.commoditiesDataFilterHover.dates = this.commoditiesData.dates;
        const filterCommDataSeries = this.commoditiesData.series.filter((d) => {
          return this.commoditiesDataFilterHover.series.some(
            (dFilter) => dFilter.short_name === d.short_name,
          );
        });
        this.commoditiesDataFilterHover.series = filterCommDataSeries;
        this.emptySelection = filterCommDataSeries.length == 0;

        // this.recalculateElementsChart(true);
        this.renderChartMethod();
      }
    },
    pickedTime(interval) {
      this.pickedTimeframe = interval;
      this.parseDataCommodities();
    },
    // === APIs ===
    // Obtain last exchange rate
    getSpotDataFn() {
      return new Promise((resolve, reject) => {
        getCandleData(this, "currency_historical")
          .then((data) => {
            const selectedD = lengthByDate(
              this.initCurrencyDate,
              data
                .filter(
                  (d) => +d.date >= this.initCurrencyDate.setHours(0, 0, 0, 0),
                )
                .map((d) => d.date),
            );
            const dataPickedTime = data.slice(-selectedD - 1);
            resolve({ allData: data, dataPickedTime });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    readCommoditiesData() {
      this.showLoading = true;
      let _this = this;
      return gatewayService.commodities
        .prices({
          format: "json",
          init_date: formatDate_YMD(this.initCurrencyDate),
        })
        .then(async (data) => {
          const columns = keys(data[0]).slice(9);
          this.commoditiesDataRaw = this.parseCommoditiesDataRaw(columns, data);
          this.commoditiesDataRaw.series.forEach((item) => {
            item.values = item.values.filter((value) => !Number.isNaN(value));
          });
          // Filter data with unit different than metric tons
          const filterDataNoMT = this.commoditiesDataRaw.series.filter(
            (d) =>
              !(
                (d.short_unit === "mt" || d.short_unit === "ton") &&
                d.is_cents === 0
              ),
          );
          // Filter data in metric tons
          const filterDataMT = this.commoditiesDataRaw.series.filter(
            (d) =>
              (d.short_unit === "mt" || d.short_unit === "ton") &&
              d.is_cents === 0,
          );
          function findConversion(commodity, conversions) {
            if (commodity.short_name == "NATGAS") {
              return {
                id: 35,
                text: "NATGAS: USD/MMBtu to USD/100 MMBtu",
                value: 100,
              };
            }

            return conversions.find((conv) => {
              const targetCurrency = commodity.is_cents === 0 ? "USD" : "USc";
              const targetUnit = commodity.short_unit;

              return (
                conv.text.includes(commodity.short_name) &&
                conv.text.includes("to USD/mt") &&
                conv.text.includes(`${targetCurrency}/${targetUnit}`)
              );
            });
          }

          function updateCommodityValues(commodity, conversion) {
            commodity.latest = commodity.latest * conversion.value;
            commodity.values = commodity.values.map(
              (value) => value * conversion.value,
            );
          }

          filterDataNoMT.forEach((commodity) => {
            const conversion = findConversion(
              commodity,
              this.commodityConversions,
            );
            if (conversion) {
              updateCommodityValues(commodity, conversion);
              if (commodity.short_name != "NATGAS") {
                commodity.short_unit = "mt";
                commodity.units = "METRIC TON";
              } else {
                commodity.short_unit = "100 mmbtu";
                commodity.units = "100 MMBtu";
              }
            }
          });

          const concatDataFilter = filterDataMT.concat(filterDataNoMT);

          Object.assign(this.commoditiesDataRaw.series, concatDataFilter);
          this.lastPrices = this.commoditiesDataRaw.series.map((d) => d.latest);
          this.parseDataCommodities(true);
          this.showLoading = false;
        })
        .catch(function(error) {
          _this.showLoading = false;
          _this.commoditiesData = [];
          console.error(error);
        });
    },
  },
};
</script>

<style>
.container-btn-play {
  width: 40px;
}

@media (max-width: 1100px) {
  .container-controls-interval {
    justify-content: flex-start !important;
  }
}

@media (max-width: 1280px) {
  .container-btn-play {
    width: 25px;
  }
}
.comm-type-label {
  font-size: 12px;
  text-transform: capitalize;
}
.comm-type-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
  cursor: pointer;
}
.comm-type-check {
  flex: 0 0 auto;
}
.comm-type-check .p-checkbox-box {
  width: 16px;
  height: 16px;
  border-width: 2px;
}
.comm-type-check .p-checkbox-icon {
  font-size: 11px;
}
.comm-type-multiselect.p-multiselect {
  width: 100%;
  min-width: 0;
}
.comm-type-multiselect .p-multiselect-label-container {
  overflow: hidden;
}
.comm-type-multiselect .p-multiselect-label {
  padding: 0.25rem 0.4rem !important;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.comm-type-multiselect .p-multiselect-trigger {
  width: 1.6rem;
}

.comm-type-selectall {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  height: 25px;
  padding: 0 5px;
  background: transparent;
  color: var(--textactive);
  border: none;
  cursor: pointer;
  font-family: "Roboto", serif;
  font-size: 0.85rem;
  outline: none;
}
.comm-type-selectall__check {
  flex: 0 0 auto;
}
.comm-type-selectall__check .p-checkbox-box {
  width: 16px;
  height: 16px;
  border-width: 2px;
}
.comm-type-selectall__check .p-checkbox-icon {
  font-size: 11px;
}
.comm-type-selectall__label {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
